// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  width: 240px;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 14px;
}

ion-select {
  margin-top: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/filter components/filter-select/filter-select.component.scss","webpack://./src/components/filter%20components/filter-select/filter-select.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;ACCJ;;ADGA;EACI,eAAA;ACAJ","sourcesContent":["ion-item {\n    width: 240px;\n    margin-left:10px;\n    margin-right:10px;\n    font-size: 14px;\n    \n}\n\nion-select{\n    margin-top:2px;\n}\n\n","ion-item {\n  width: 240px;\n  margin-left: 10px;\n  margin-right: 10px;\n  font-size: 14px;\n}\n\nion-select {\n  margin-top: 2px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
